import {
  CUSTOMERS_REQUEST, CUSTOMERS_SUCCESS, CUSTOMERS_FAILURE,
  CUSTOMER_REQUEST, CUSTOMER_SUCCESS, CUSTOMER_FAILURE,
  CUSTOMER_ADD_REQUEST, CUSTOMER_ADD_SUCCESS, CUSTOMER_ADD_FAILURE,
  CUSTOMER_UPDATE_REQUEST, CUSTOMER_UPDATE_SUCCESS, CUSTOMER_UPDATE_FAILURE,
  CUSTOMER_RESET,
  CUSTOMERSCASH_REQUEST, CUSTOMERSCASH_SUCCESS, CUSTOMERSCASH_FAILURE,
  CUSTOMERCASH_REQUEST, CUSTOMERCASH_SUCCESS, CUSTOMERCASH_FAILURE,
  CUSTOMERCASH_ADD_REQUEST, CUSTOMERCASH_ADD_SUCCESS, CUSTOMERCASH_ADD_FAILURE,
  CUSTOMERCASH_UPDATE_REQUEST, CUSTOMERCASH_UPDATE_SUCCESS, CUSTOMERCASH_UPDATE_FAILURE,
  CUSTOMERSPDA_REQUEST, CUSTOMERSPDA_SUCCESS, CUSTOMERSPDA_FAILURE,
  CUSTOMERPDA_REQUEST, CUSTOMERPDA_SUCCESS, CUSTOMERPDA_FAILURE,
  CUSTOMERPDA_ADD_REQUEST, CUSTOMERPDA_ADD_SUCCESS, CUSTOMERPDA_ADD_FAILURE,
  CUSTOMERPDA_UPDATE_REQUEST, CUSTOMERPDA_UPDATE_SUCCESS, CUSTOMERPDA_UPDATE_FAILURE,
  CUSTOMERSGROUP_REQUEST, CUSTOMERSGROUP_SUCCESS, CUSTOMERSGROUP_FAILURE,
  CUSTOMERGROUP_REQUEST, CUSTOMERGROUP_SUCCESS, CUSTOMERGROUP_FAILURE,
  CUSTOMERGROUP_ADD_REQUEST, CUSTOMERGROUP_ADD_SUCCESS, CUSTOMERGROUP_ADD_FAILURE,
  CUSTOMERGROUP_UPDATE_REQUEST, CUSTOMERGROUP_UPDATE_SUCCESS, CUSTOMERGROUP_UPDATE_FAILURE,
  MYCASH_REQUEST, MYCASH_SUCCESS, MYCASH_FAILURE,
  MYCASH_UPDATE_REQUEST, MYCASH_UPDATE_SUCCESS, MYCASH_UPDATE_FAILURE,
  MYCASH_ADD_REQUEST, MYCASH_ADD_SUCCESS, MYCASH_ADD_FAILURE,
  MYCASH_DELETE_REQUEST, MYCASH_DELETE_SUCCESS, MYCASH_DELETE_FAILURE,
  MYPDA_REQUEST, MYPDA_SUCCESS, MYPDA_FAILURE,
  MYPDA_UPDATE_REQUEST, MYPDA_UPDATE_SUCCESS, MYPDA_UPDATE_FAILURE,
  MYPDA_ADD_REQUEST, MYPDA_ADD_SUCCESS, MYPDA_ADD_FAILURE,
  MYPDA_DELETE_REQUEST, MYPDA_DELETE_SUCCESS, MYPDA_DELETE_FAILURE

} from '../actions/customers'

const INITIAL_STATE = {
  customers: null, customersNeedRefresh: false, customer: null, error: null,
  loading: false,
  myCashUsers: null, myPdaUsers: null, myUsersLoading: false, myUsersError: null
}

const customersReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CUSTOMERS_REQUEST:
      return {
        ...state,
        customers: null, error: null, loading: true
      }
    case CUSTOMERS_SUCCESS:
      return {
        ...state,
        customers: action.response, error: null, loading: false
      }
    case CUSTOMERS_FAILURE:
      return {
        ...state,
        error: action.error, loading: false
      }
    case CUSTOMER_REQUEST:
      return {
        ...state,
        error: null, loading: true
      }
    case CUSTOMER_SUCCESS:
      return {
        ...state,
        customer: action.response, error: null, loading: false
      }
    case CUSTOMER_FAILURE:
      return {
        ...state,
        error: action.error, loading: false
      }
    case CUSTOMER_ADD_REQUEST:
      return {
        ...state,
        error: null, loading: true
      }
    case CUSTOMER_ADD_SUCCESS:
      return {
        ...state,
        customer: action.response, customersNeedRefresh: true, error: null,
        loading: false
      }
    case CUSTOMER_ADD_FAILURE:
      return {
        ...state,
        error: action.error, loading: false
      }
    case CUSTOMER_UPDATE_REQUEST:
      return {
        ...state,
        error: null, loading: true
      }
    case CUSTOMER_UPDATE_SUCCESS:
      const updatedCustomers = state.customers ? state.customers.map(c => c._id === action.response._id ? action.response : c) : state.customers;
      return {
        ...state,
        customer: action.response, customers: updatedCustomers, error: null,
        loading: false
      }
    case CUSTOMER_UPDATE_FAILURE:
      return {
        ...state,
        error: action.error, loading: false
      }
    case CUSTOMER_RESET:
      return {
        ...state,
        customer: null, error: null, loading: false
      }
    case CUSTOMERSCASH_REQUEST:
      return {
        ...state,
        customers: null, error: null, loading: true
      }
    case CUSTOMERSCASH_SUCCESS:
      return {
        ...state,
        customers: action.response, error: null, loading: false
      }
    case CUSTOMERSCASH_FAILURE:
      return {
        ...state,
        error: action.error, loading: false
      }
    case CUSTOMERCASH_REQUEST:
      return {
        ...state,
        error: null, loading: true
      }
    case CUSTOMERCASH_SUCCESS:
      return {
        ...state,
        customer: action.response, error: null, loading: false
      }
    case CUSTOMERCASH_FAILURE:
      return {
        ...state,
        error: action.error, loading: false
      }
    case CUSTOMERCASH_ADD_REQUEST:
      return {
        ...state,
        error: null, loading: true
      }
    case CUSTOMERCASH_ADD_SUCCESS:
      return {
        ...state,
        customer: action.response, customersNeedRefresh: true, error: null,
        loading: false
      }
    case CUSTOMERCASH_ADD_FAILURE:
      return {
        ...state,
        error: action.error, loading: false
      }
    case CUSTOMERCASH_UPDATE_REQUEST:
      return {
        ...state,
        error: null, loading: true
      }
    case CUSTOMERCASH_UPDATE_SUCCESS:
      return {
        ...state,
        customer: action.response, customersNeedRefresh: true, error: null,
        loading: false
      }
    case CUSTOMERCASH_UPDATE_FAILURE:
      return {
        ...state,
        error: action.error, loading: false
      }
    case CUSTOMERSPDA_REQUEST:
      return {
        ...state,
        customers: null, error: null, loading: true
      }
    case CUSTOMERSPDA_SUCCESS:
      return {
        ...state,
        customers: action.response, error: null, loading: false
      }
    case CUSTOMERSPDA_FAILURE:
      return {
        ...state,
        error: action.error, loading: false
      }
    case CUSTOMERPDA_REQUEST:
      return {
        ...state,
        error: null, loading: true
      }
    case CUSTOMERPDA_SUCCESS:
      return {
        ...state,
        customer: action.response, error: null, loading: false
      }
    case CUSTOMERPDA_FAILURE:
      return {
        ...state,
        error: action.error, loading: false
      }
    case CUSTOMERPDA_ADD_REQUEST:
      return {
        ...state,
        error: null, loading: true
      }
    case CUSTOMERPDA_ADD_SUCCESS:
      return {
        ...state,
        customer: action.response, customersNeedRefresh: true, error: null,
        loading: false
      }
    case CUSTOMERPDA_ADD_FAILURE:
      return {
        ...state,
        error: action.error, loading: false
      }
    case CUSTOMERPDA_UPDATE_REQUEST:
      return {
        ...state,
        error: null, loading: true
      }
    case CUSTOMERPDA_UPDATE_SUCCESS:
      return {
        ...state,
        customer: action.response, customersNeedRefresh: true, error: null,
        loading: false
      }
    case CUSTOMERPDA_UPDATE_FAILURE:
      return {
        ...state,
        error: action.error, loading: false
      }
      case CUSTOMERSGROUP_REQUEST:
        return {
          ...state,
          customers: null, error: null, loading: true
        }
      case CUSTOMERSGROUP_SUCCESS:
        return {
          ...state,
          customers: action.response, error: null, loading: false
        }
      case CUSTOMERSGROUP_FAILURE:
        return {
          ...state,
          error: action.error, loading: false
        }
      case CUSTOMERGROUP_REQUEST:
        return {
          ...state,
          error: null, loading: true
        }
      case CUSTOMERGROUP_SUCCESS:
        return {
          ...state,
          customer: action.response, error: null, loading: false
        }
      case CUSTOMERGROUP_FAILURE:
        return {
          ...state,
          error: action.error, loading: false
        }
      case CUSTOMERGROUP_ADD_REQUEST:
        return {
          ...state,
          error: null, loading: true
        }
      case CUSTOMERGROUP_ADD_SUCCESS:
        return {
          ...state,
          customer: action.response, customersNeedRefresh: true, error: null,
          loading: false
        }
      case CUSTOMERGROUP_ADD_FAILURE:
        return {
          ...state,
          error: action.error, loading: false
        }
      case CUSTOMERGROUP_UPDATE_REQUEST:
        return {
          ...state,
          error: null, loading: true
        }
      case CUSTOMERGROUP_UPDATE_SUCCESS:
        return {
          ...state,
          customer: action.response, customersNeedRefresh: true, error: null,
          loading: false
        }
      case CUSTOMERGROUP_UPDATE_FAILURE:
        return {
          ...state,
          error: action.error, loading: false
        }
    case MYCASH_REQUEST:
      return { ...state, myUsersLoading: true, myUsersError: null }
    case MYCASH_SUCCESS:
      return { ...state, myCashUsers: Array.isArray(action.response) ? action.response : [], myUsersLoading: false }
    case MYCASH_FAILURE:
      return { ...state, myUsersError: action.error, myUsersLoading: false }
    case MYCASH_UPDATE_REQUEST:
      return { ...state, myUsersLoading: true, myUsersError: null }
    case MYCASH_UPDATE_SUCCESS:
      return {
        ...state,
        myCashUsers: state.myCashUsers
          ? state.myCashUsers.map(u => u._id === action.response._id ? action.response : u)
          : state.myCashUsers,
        myUsersLoading: false
      }
    case MYCASH_UPDATE_FAILURE:
      return { ...state, myUsersError: action.error, myUsersLoading: false }
    case MYCASH_ADD_REQUEST:
      return { ...state, myUsersLoading: true, myUsersError: null }
    case MYCASH_ADD_SUCCESS:
      return { ...state, myCashUsers: [...(state.myCashUsers || []), action.response], myUsersLoading: false }
    case MYCASH_ADD_FAILURE:
      return { ...state, myUsersError: action.error, myUsersLoading: false }
    case MYCASH_DELETE_REQUEST:
      return { ...state, myUsersLoading: true, myUsersError: null }
    case MYCASH_DELETE_SUCCESS:
      return { ...state, myUsersLoading: false }
    case MYCASH_DELETE_FAILURE:
      return { ...state, myUsersError: action.error, myUsersLoading: false }
    case MYPDA_REQUEST:
      return { ...state, myUsersLoading: true, myUsersError: null }
    case MYPDA_SUCCESS:
      return { ...state, myPdaUsers: Array.isArray(action.response) ? action.response : [], myUsersLoading: false }
    case MYPDA_FAILURE:
      return { ...state, myUsersError: action.error, myUsersLoading: false }
    case MYPDA_UPDATE_REQUEST:
      return { ...state, myUsersLoading: true, myUsersError: null }
    case MYPDA_UPDATE_SUCCESS:
      return {
        ...state,
        myPdaUsers: state.myPdaUsers
          ? state.myPdaUsers.map(u => u._id === action.response._id ? action.response : u)
          : state.myPdaUsers,
        myUsersLoading: false
      }
    case MYPDA_UPDATE_FAILURE:
      return { ...state, myUsersError: action.error, myUsersLoading: false }
    case MYPDA_ADD_REQUEST:
      return { ...state, myUsersLoading: true, myUsersError: null }
    case MYPDA_ADD_SUCCESS:
      return { ...state, myPdaUsers: [...(state.myPdaUsers || []), action.response], myUsersLoading: false }
    case MYPDA_ADD_FAILURE:
      return { ...state, myUsersError: action.error, myUsersLoading: false }
    case MYPDA_DELETE_REQUEST:
      return { ...state, myUsersLoading: true, myUsersError: null }
    case MYPDA_DELETE_SUCCESS:
      return { ...state, myUsersLoading: false }
    case MYPDA_DELETE_FAILURE:
      return { ...state, myUsersError: action.error, myUsersLoading: false }
    default:
      return state
  }
}

export default customersReducer

